import { render, staticRenderFns } from "./insurancePlan.vue?vue&type=template&id=5a79cdbf&scoped=true&"
import script from "./insurancePlan.vue?vue&type=script&lang=js&"
export * from "./insurancePlan.vue?vue&type=script&lang=js&"
import style0 from "./insurancePlan.vue?vue&type=style&index=0&lang=less&"
import style1 from "./insurancePlan.vue?vue&type=style&index=1&id=5a79cdbf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79cdbf",
  null
  
)

export default component.exports